module.exports = __webpack_public_path__ + "img/4-8627.1ea6b905.png";